<template>
  <BaseBlock
    amplitude-opportunity-type-name="quick-wins-dashboard"
    :metric
    :translations
    @on-open="handleOnOpen"
    @on-pagination-changed="handleOnPaginationChanged"
    @on-update="$emit('on-update')"
  />
</template>

<script setup lang="ts">
import type { sellerOpportunities } from '@backmarket/http-api'
import { useTracking } from '@backmarket/nuxt-module-tracking/useTracking'

import BaseBlock from '../BaseBlock/BaseBlock.vue'

import translations from './BlockQuickWins.translations'

const { trackPaginationClicked, trackClick } = useTracking()

defineProps<{
  metric: sellerOpportunities.PricingOpportunitiesMetric
}>()

defineEmits(['on-update'])

function handleOnPaginationChanged() {
  trackPaginationClicked({
    name: 'pagination_clicked',
    page_type: 'opportunities_pricing',
    zone: 'opportunities_pricing_quickwins_lists',
  })
}

function handleOnOpen() {
  trackClick({
    name: 'quick-wins',
    page_type: 'opportunities_pricing',
    zone: 'opportunities_pricing_dashboards',
  })
}
</script>
